import './sass/index.scss';
import './js/components/hamburger-menu';
import './js/components/catalog';
import './js/components/reviews';
import './js/components/delivery';
import './js/components/scroll';
import './js/components/back-to-top';
import './js/components/basket';
import './js/components/modal-basket';
import './js/components/modal-order';
import './js/components/form-order';
